<template>
    <img :src="co_getImg_r" :alt="co_att_s"
         loading="lazy"
         :onerror="`this.onerror=null;this.src='${pb_defaultImg_r}'`" />
</template>

<script>
    import {ass_img_image2} from "@/assets/scripts/Ass_Files";

    export default {
        name: "TqImage",
        props:{
            pb_src_r:{
                type: String,
            },
            pb_defaultImg_r:{
                type: String,
                default : ass_img_image2
            },
            pb_att_s:{
                type: String,
                require: true,
            },

        },
        computed:{

            co_getImg_r(){

                if(this.pb_src_r != null)
                    return this.pb_src_r

                return this.pb_defaultImg_r

            },

            co_att_s(){

                if(this.co_getImg_r == null && this.pb_att_s == null){
                    return 'No Image'
                }else if(this.pb_att_s != null){
                   return this.pb_att_s
                }

                let ans = this.co_getImg_r


                // ans = ans.replace(new RegExp("_", 'g'), " ",)
                // ans = ans.replace(new RegExp("/", 'g'), " ",)

                return ans
            }
        }
    }
</script>

<style scoped>


</style>